// extracted by mini-css-extract-plugin
export default {"red":"#db1c1c","green":"#45b562"};